import React, { Fragment } from 'react';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';
import { Text, Heading, Box } from 'roo-ui/components';
import ContentRow from 'pages/BookingConfirmation/ContentRow';
import ContentWrapper from 'pages/BookingConfirmation/ContentWrapper';
import { getProperty } from 'store/booking/bookingSelectors';
import Markup from 'components/Markup';

const StyledText = styled(Text)`
  line-height: 1.75;
`;

const CheckInInformation = () => {
  const property = useSelector(getProperty);
  const { checkOutBefore, checkInAfter, checkInInstructions } = property;
  const hasCheckInInstruction = !!checkInInstructions;

  return (
    <Fragment>
      <Heading.h3 fontSize={['base', 'md']} mb={4} data-testid="property_name">
        Check-in and Check-out
      </Heading.h3>
      <ContentWrapper>
        <ContentRow>
          <Box width={[0.5, 0.2]}>
            <StyledText fontSize={['sm', 'base']} data-testid="check-in-label" fontWeight="bold" color="greys.charcoal">
              Check-in time
            </StyledText>
            <br />
            <StyledText fontSize={['sm', 'base']} data-testid="check-in-time">
              From {checkInAfter}
            </StyledText>
          </Box>
          <Box>
            <StyledText fontSize={['sm', 'base']} data-testid="check-out-label" fontWeight="bold" color="greys.charcoal">
              Check-out time
            </StyledText>
            <br />
            <StyledText fontSize={['sm', 'base']} data-testid="check-out-time">
              Until {checkOutBefore}
            </StyledText>
          </Box>
        </ContentRow>
      </ContentWrapper>
      {hasCheckInInstruction && (
        <Fragment>
          <Heading.h3 fontSize="base" mb={1} mt={8} data-testid="check-in-instructions-title">
            Check-in instructions
          </Heading.h3>
          <Text fontSize={['sm', 'base']}>
            <Markup content={checkInInstructions} />
          </Text>
        </Fragment>
      )}
    </Fragment>
  );
};

export default CheckInInformation;
